module.exports = __webpack_public_path__ + "static/media/elastic-cluster--full-color.579acca5.png";